import React from "react";
import { IBillingCompanyContextState } from "./BillingCompanyProvider.types";
import { defaultBillingCompanyContextState } from "./BillingCompanyProvider.state";
import { useAuth } from "../../contexts/AuthProvider/AuthProvider";
import { BillingCompanyContext } from "./BillingCompanyProvider.context";
import { fetchBillingCompanyInfoAsync } from "./BillingCompanyProvider.services";
import { LinearProgress } from "@mui/material";
import { NoBillingComapnyScreen } from "./views/NoBillingComapnyScreen";
import { saveBillingCompanyInStorage } from "./BillingCompanyProvider.storage";

export const BillingCompanyProvider: React.FC<{ children: React.ReactNode }> = (
	props
) => {
	const [outletInfo, setOutletInfo] =
		React.useState<IBillingCompanyContextState>(
			defaultBillingCompanyContextState
		);
	const [loading, setLoading] = React.useState(false);
	const [zeroOutletDialog, setZeroOutletDialog] =
		React.useState<boolean>(false);

	const { user } = useAuth();
	const { role_value, userUuid, affilated_company_outlet_uuids } = user;

	const isAdmin =
		role_value === "ADMIN" ||
		role_value === "SUPERADMIN" ||
		role_value === "ENR_ADMIN";

	React.useEffect(() => {
		if (!userUuid) return;
		getOutDetails();
	}, [userUuid]);

	const getOutDetails = async () => {
		setLoading(true);
		const validCompany = await fetchBillingCompanyInfoAsync(
			affilated_company_outlet_uuids
		);
		if (validCompany) {
			saveBillingCompanyInStorage(validCompany.comapny);
			setOutletInfo(validCompany);
		} else {
			setZeroOutletDialog(true);
		}
		setLoading(false);
	};

	if (loading) return <LinearProgress />;

	if (!isAdmin && userUuid && zeroOutletDialog)
		return <NoBillingComapnyScreen />;

	return (
		<BillingCompanyContext.Provider value={outletInfo}>
			{props.children}
		</BillingCompanyContext.Provider>
	);
};
